import {
  LOAD_BUILDER_TEMPLATES,
  LOAD_BUILDER_TEMPLATES_FAIL,
  LOAD_BUILDER_TEMPLATES_SUCCESS, LOAD_IMPORTING_BUILDER_TEMPLATE, LOAD_IMPORTING_BUILDER_TEMPLATE_FAIL,
  LOAD_BUILDER_TEMPLATES_CATEGORIES, LOAD_BUILDER_TEMPLATES_CATEGORIES_SUCCESS, LOAD_BUILDER_TEMPLATES_CATEGORIES_FAIL,
  LOAD_IMPORTING_BUILDER_TEMPLATE_SUCCESS,
  LOAD_LAST_BUILDER_TEMPLATE,
  LOAD_LAST_BUILDER_TEMPLATE_FAIL,
  LOAD_LAST_BUILDER_TEMPLATE_SUCCESS,
  LoadBuilderTemplatesSuccess, LoadImportingBuilderTemplate, LoadImportingBuilderTemplateSuccess,
  LoadLastBuilderTemplate, LoadLastBuilderTemplateSuccess,
  LoadBuilderTemplatesCategories, LoadBuilderTemplatesCategoriesSuccess
} from '../actions/builder-templates.action';
import {
  BuilderTemplatesAction
} from "../actions";
import {BuilderTemplates} from "../../websites/website/builder-templates/builder-templates";

export interface IBuilderTemplateState {
  entities: {[websiteId: number]: any};
  lastEntities: {[websiteId: number]: BuilderTemplates};
  categoriesEntities: {};
  loading: boolean;
  loaded: boolean;
}

export const initialState: IBuilderTemplateState = {
  entities: {},
  lastEntities: {},
  categoriesEntities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IBuilderTemplateState = initialState, action: BuilderTemplatesAction): IBuilderTemplateState {
  let payload: any;

  switch (action.type) {

    case LOAD_BUILDER_TEMPLATES_CATEGORIES:
      payload = (<LoadBuilderTemplatesCategories>action);
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case LOAD_BUILDER_TEMPLATES_CATEGORIES_SUCCESS:
      payload = (<LoadBuilderTemplatesCategoriesSuccess>action).payload;

      return {
        ...state,
        categoriesEntities: payload,
        loading: false,
        loaded: true
      };

    case LOAD_BUILDER_TEMPLATES_CATEGORIES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true
      };



    case LOAD_BUILDER_TEMPLATES:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case LOAD_BUILDER_TEMPLATES_SUCCESS:
      payload = (<LoadBuilderTemplatesSuccess>action).payload;

      return {
        ...state,
        entities: payload,
        loading: false,
        loaded: true
      };

    case LOAD_BUILDER_TEMPLATES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true
      };


    case LOAD_LAST_BUILDER_TEMPLATE:
      payload = (<LoadLastBuilderTemplate>action).payload;
      return {
        ...state,
        lastEntities: payload.lastEntities,
        loading: true,
        loaded: false
      };


    case LOAD_LAST_BUILDER_TEMPLATE_SUCCESS:
      payload = (<LoadLastBuilderTemplateSuccess>action).payload;

      return {
        ...state,
        lastEntities: payload.lastEntities,
        loading: false,
        loaded: true
      };

    case LOAD_LAST_BUILDER_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true
      };

    case LOAD_IMPORTING_BUILDER_TEMPLATE:
      payload = (<LoadImportingBuilderTemplate>action);
      return {
        ...state,
        lastEntities: payload.payload,
        loading: true,
        loaded: false
      };


    case LOAD_IMPORTING_BUILDER_TEMPLATE_SUCCESS:
      payload = (<LoadImportingBuilderTemplateSuccess>action).payload;

      return {
        ...state,
        lastEntities: payload,
        loading: false,
        loaded: true
      };

    case LOAD_IMPORTING_BUILDER_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true
      };


  }

  return state;
}
